import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel, Tc } from '../../../../core/_infrastructure/types/common';
import { PuntoInspeccionService } from '../puntoinspeccion.service';
import { FilterSearchingPuntoInspeccionViewModel, PuntoInspeccionItemResultsViewModel } from '../puntoinspeccion.types';

@Component({
    selector: 'app-puntoinspeccion-wrapper-search',
    templateUrl: './puntoinspeccion-wrapper-search.component.html',
})
export class PuntoInspeccionWrapperSearchComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    listPuntoInspeccion: PuntoInspeccionItemResultsViewModel | null;
    edition = false;

    listPais: Tc[];
    listMunicipio: Tc[] | null;
    listProvincia: Tc[] | null;
    listTipoPuntoInspeccion: Tc[] | null;

    modelosCf: Tc[];

    private route = 'mantenimiento/general/puntosinspeccion';

    payload?: FilterSearchingPuntoInspeccionViewModel;
    paisEspania = 0;

    constructor(
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private pifService: PuntoInspeccionService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.paisEspania = parseInt(this.getConfig().IdPaisEspania);

        this.getPaises();

        this.recoverLastSearch();
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.pifService.getLastSearch();
    }

    /**
     * Invoca a un método global de la API para obtener la lista de países
     * @return void
     */
    private getPaises(): void {
        this.globalService.getAllPaises().subscribe((result: Tc[]) => {
            this.listPais = result;
        });
    }

    onSelectProvincia(idProvincia: number) {
        this.globalService.getMunicipios(idProvincia).subscribe((result: Tc[]) => {
            this.listMunicipio = result;
        });
    }

    onSelectPais(idPais: number) {
        if (idPais == this.paisEspania) {
            this.globalService.getProvincias().subscribe((result: Tc[]) => {
                this.listProvincia = result;
            });
            this.globalService.getTipoPuntoInspeccion().subscribe((result: Tc[]) => {
                this.listTipoPuntoInspeccion = result;
            });
        } else {
            this.listProvincia = null;
            this.listTipoPuntoInspeccion = null;
            this.listMunicipio = null;
        }
    }

    onSearch(payload: FilterSearchingPuntoInspeccionViewModel): void {
        if (!payload) {
            return;
        }
        this.payload = { ...payload } as FilterSearchingPuntoInspeccionViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.pifService.getList(payload).subscribe((results: PuntoInspeccionItemResultsViewModel) => {
            this.listPuntoInspeccion = results;
            this.searching = true;
        });
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingPuntoInspeccionViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onCleanForm(): void {
        this.searching = false;
        this.listPuntoInspeccion = null;
        this.pifService.resetFilter();
    }

    /**
     * Redirigimos al formulario de creación de una nuevo pif
     * @return void
     */
    onAdd(): void {
        this.edition = true;

        this.router.navigate([this.route + '/create']);
    }

    onPorcentajes(): void {
        this.router.navigate([this.route + '/porcentajes']);
    }

    /**
     * Redirigimos al formulario de edición del pif
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onEdit(itemId: number | null): void {
        this.edition = true;
        this.router.navigate([this.route + '/edit', itemId]);
    }

    onDelete(id: number) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.pifService.delete(id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Punto de Inspección eliminado correctamente');
                        this.onSearch(this.payload!);
                    },
                    error: () => {
                        this.addErrorMessage('Error al borrar el PIF. Puede que no se pueda eliminar porque ha sido utilizado en alguna solicitud.');
                    },
                });
            },
        });
    }

    /**
     * Invoked when the user wants to export the result to excel
     * @return void
     */
    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingPuntoInspeccionViewModel = new FilterSearchingPuntoInspeccionViewModel();
        Object.assign(model, this.payload);

        this.pifService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.listPuntoInspeccion?.ResultList ? this.listPuntoInspeccion?.ResultList?.length > 0 : false;
    }
}
